import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { styled } from '@material-ui/core/styles';
import { isMobile } from "react-device-detect";
import { LocalVideoTrack, LocalAudioTrack } from 'twilio-video';
import Controls from '../../../components/Controls/videoRoom/Controls';
import LocalVideoPreview from '../../../components/LocalVideoPreview/LocalVideoPreview';
import MenuBar from '../../../components/MenuBar/MenuBar';
import ReconnectingNotification from '../../../components/ReconnectingNotification/ReconnectingNotification';
import Room from '../../../components/Room/videoRoom/Room';

import useRoomState from '../../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useAppState } from '../../../state';
import Loader from '../../../components/Loader/parentVideoLoader';
import PermissionBox from '../../../components/permissionBox/permissionBox'; 

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
});

const Main = styled('main')({
  height: '100%',
  position: 'relative',
});

export default function App(props : any) {
  const roomState = useRoomState();
  const [visible, setVisible] = useState(false);
  
  const { patient, setting } = props;
  const{ activeCall } = patient;
  
  const { currentUser } = setting;
  const { connect, localTracks, getLocalVideoTrack } = useVideoContext();
  const { getToken, isFetching } = useAppState();
  const videoTrack = localTracks.find(track => track.name === 'camera') as LocalVideoTrack;
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;


  useEffect(() => {
    window.onbeforeunload = (e: any) =>{
      window.sessionStorage.removeItem('twilioPatientToken');
      window.sessionStorage.setItem('patientConnecting', "no");
    }

    const twilioToken = window.sessionStorage.getItem('twilioPatientToken');
    const patientConnecting = window.sessionStorage.getItem('patientConnecting');
    if(patientConnecting !== "yes" && videoTrack && audioTrack){
      audioTrack.enable();
      if(videoTrack && videoTrack.isStopped){
        getLocalVideoTrack();
      }
      if(twilioToken && twilioToken !== "" && !isFetching){
        connect(twilioToken, props);
        window.sessionStorage.setItem('patientConnecting', "yes");
      }else if(!isFetching){
        let patientName = activeCall.patient.split(" ")[0] + (activeCall.patient.split(" ")[1] ? activeCall.patient.split(" ")[1] : "");
        let mobileNumber = props.setting && props.setting.currentUser && props.setting.currentUser.mobileNumber
        if(!mobileNumber || mobileNumber == "" || mobileNumber == null){
          
          if(window.localStorage.getItem('user') && window.localStorage.getItem('user') !== null && window.localStorage.getItem('user') && window.localStorage.getItem('user') != ''){
            mobileNumber = window.localStorage.getItem('user')

          }
        }
        let userId =  mobileNumber && mobileNumber != "" ?  mobileNumber + "" : patientName + "_" + Math.floor(Math.random() * 90 + 10)

        //let userId =  mobileNumber && mobileNumber != "" ?  patientName + "_" + mobileNumber + "" : patientName + "_" + Math.floor(Math.random() * 90 + 10)

        getToken(userId, activeCall.therapistRoom).then((token: any) => {
            if(token === ""){
              return;
            }
            window.sessionStorage.setItem('twilioPatientToken', token);
            window.sessionStorage.setItem('patientConnecting', "yes");
            connect(token, props);
          });
      }
    }
  });
  // if(activeCall.isMute === "true" && audioTrack){
  //   audioTrack.disable();
  // }
  if (!window.sessionStorage.getItem('twilioPatientToken')) {
    if (!(audioTrack && videoTrack)) {      
      return <div>
        {isMobile && <header className="sectionHeader">
          <div className="menu-icon" onClick={props.toggleSidebar}>
            <span></span><span></span><span></span>
          </div>
          <div className="m-logo">
            <a><img className="logo" src="/images/kure-logo.png" width="70" alt="kure logo" /></a>
            <h3>video room</h3>
          </div>
          {/* <div className="top-bar">
                <h1>To invite someone to your waiting room, share this link:</h1>
        
            </div> */}

        </header>}
        <PermissionBox camNamee={activeCall.patient} showLocalVideo={props.showLocalVideo} verifyUser={props.verifyUser} />

        <div className="call-waiting-msg">
          <div className='camera-permission'>
            Your camera and microphone are not enabled yet. Allow access by changing your settings using the<span> &nbsp;<img src="/images/chrome-camera-block.png" width="18" />&nbsp; </span>&nbsp;icon in the address bar.
            
            <a  className="moreinfo" onClick={() => setVisible(true)}>more info</a>
            <Modal
              className="cameraAcessModal"
              width={700}
              visible={visible}
              onCancel={() => setVisible(false)}
              footer=""
              >
                <div className="cameraAcessContent">
                  <h1>Camera and microphone access</h1>
                  <p>To double check your camera and microphone are enables:</p>
                  <ul>
                    <li>Select the lock icon positioned on the right of your address bar.</li>
                    <li>Make sure the dropdown next to the camera and microphone are allowed access</li>
                    <li>Refresh the browser tab (cmd + R on Mac, or Ctrl + R / F5 on Windows).</li>
                  </ul>
                  <div className="permission-screenshot">
                    <img src="/images/chrome-permissions.png" width="309" />
                  </div>
                </div>
            </Modal>
          </div>
          <button className="exitvideoRoom_btn" onClick={props.endCall}>exit video room</button>
        </div>
      </div>
    }
    return <Loader />
  }


  return (
    <Container>
      <Main className={"main-room-container mt-0" + (isMobile ? " mobile-container" : "")}>
       
        {roomState === 'disconnected' ? <LocalVideoPreview /> : <Room {...props}  currentUser={((currentUser && currentUser.mobileNumber) ? currentUser.mobileNumber : "")} />}
        <Controls {...props} videoTrack={videoTrack} audioTrack={audioTrack}/>
      </Main>
      <ReconnectingNotification />
    </Container>
  );
}
